// copied code from NedBrowser repo

function calculateIntervalValue(start, eind, aantal, volgnummer) {
    if (aantal > 1 && volgnummer > 0) {
        return start + (eind - start) / (aantal) * volgnummer;
    } else if (aantal === 1) {
        if (volgnummer === 0) {
            return start;
        } else {
            return eind;
        }
    } else {
        return start;
    }
}

function round(getal, afrondingseenheid) {
    return (Math.round(getal / afrondingseenheid) * afrondingseenheid);
}

export function getIntervals(min, max, tal_klassen, afrondingseenheid) {
    let intervals = [];
    let ondergrens;
    let bovengrens;

    for (let i = 0; i < tal_klassen; i++) {
        ondergrens = calculateIntervalValue(min, max, tal_klassen, i);
        ondergrens = round(ondergrens, afrondingseenheid);
        bovengrens = calculateIntervalValue(min, max, tal_klassen, i + 1);

        // Zorg ervoor dat de eerste ondergrens naar beneden wordt afgerond
        if (i === 0) {
            if (round(ondergrens, afrondingseenheid) > ondergrens) {
                ondergrens = round(ondergrens, afrondingseenheid) - afrondingseenheid;
            } else {
                ondergrens = round(ondergrens, afrondingseenheid);
            }
        } else {
            ondergrens = round(ondergrens, afrondingseenheid);
        }

        // Zorg ervoor dat de laatste bovengrens naar boven wordt afgerond
        if (i === tal_klassen - 1) {
            if (round(bovengrens, afrondingseenheid) < bovengrens) {
                bovengrens = round(bovengrens, afrondingseenheid) + afrondingseenheid;
            } else {
                bovengrens = round(bovengrens, afrondingseenheid);
            }
        } else {
            bovengrens = round(bovengrens, afrondingseenheid);
        }
        intervals.push([ondergrens, bovengrens]);
    }
    return intervals;
}
